import React from "react"

import {FieldAutomationConditionFormProps} from "../../../../render/automation-condition-form"
import {SelectParent_RenderType} from "../../../../../gd-ui/select-parent-new/@const"
import SelectParentsNew from "../../../../../gd-ui/select-parent-new/select-parents-new"
import FieldProjects from "../projects"

// const debug = "FieldProjects_AutomationConditionForm"
const debug = false

export default class FieldProjects_AutomationConditionForm extends React.Component<FieldAutomationConditionFormProps,any> {

    onChangeFieldValues = (projectIds: []) => this.props.onChangeCallback({fieldValues: projectIds})

    render() {
        return (
            <div className="flex-row-left-top">
                <div className="label">is</div>
                <SelectParentsNew className     = "selector always-selected"
                                  renderType    = {SelectParent_RenderType.INLINE_EDITABLE}
                                  placeholder   = "Any"
                                  unselectLabel = "Any"
                                  parentsFor    = {(this.props.field as FieldProjects).parentsFor}
                                  projectIds    = {this.props.config.fieldValues}
                                  onChange      = {this.onChangeFieldValues}/>

                {/*<SelectParent className         = "selector always-selected"
                              renderValue       = "inline-editable"
                              parentsFor        = "common-use"
                              viewMode          = "all"
                              multiselect       = {true}
                              placeholder       = "Any"
                              unselectLabel     = "Any"
                              companies         = {[gd.companyId]}
                              values            = {this.props.config.fieldValues ? {projects: this.props.config.fieldValues} : null}
                              showProjectIcon   = {true}
                              showIcon          = {true}
                              searchable        = {true}
                              onChange          = {this.onChangeFieldValues}/>*/}
            </div>
        )
    }
}


